"use strict";

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

Shopify.theme.jsCart = {
  init: function init($section) {
    // Add settings from schema to current object
    //Shopify.theme.jsCart = $.extend(this, Shopify.theme.getSectionData($section));
    this.$section = $section;
    $(document).on('click', '[data-cart-page-delete]', function (e) {
      e.preventDefault();
      var lineID = $(this).data('line-item-key');
      Shopify.theme.jsCart.removeFromCart(lineID);
      return false;
    });
  },
  removeFromCart: function removeFromCart(lineID) {
    var $cartItem = Shopify.theme.jsCart.$section.find("[data-line-item=\"".concat(lineID, "\"]"));
    var qty = Number($cartItem[0].querySelector(".quantity-input").value);
    var price = Number($cartItem[0].querySelector(".cart__price").dataset.price);
    var sku = $cartItem[0].dataset.sku;
    var title = $cartItem[0].dataset.title;

    $cartItem.css('opacity', '0.5');

    $.ajax({
      type: 'POST',
      url: '/cart/change.js',
      data: 'quantity=0&line=' + lineID,
      dataType: 'json',
      success: function success(cart) {
        $cartItem.addClass('animated zoomOut');
        $cartItem.remove();

        function runOperations() {
          Shopify.theme.jsCart.updateView(cart, lineID);

          if (typeof Shopify.theme.jsAjaxCart !== 'undefined') {
            Shopify.theme.jsAjaxCart.updateView();
          }

          jQuery.ajax({
            dataType: 'json',
            url: '/cart',
            cache: false,
            success: function(response) {
              var has_final_sale = 0;
              var cart_has_final_sale = false;

              if (response.attributes['Final Sale'] != undefined) {
                cart_has_final_sale = true;
              }

              for (let i = 0; i < response.items.length; i++) {
                console.log(response.items[i])
                console.log(response.items[i].properties);
                console.log(response.items[i].properties['Final Sale']);
                if (response.items[i].properties['Final Sale'] != undefined) {
                  has_final_sale = has_final_sale + 1;
                }
              }

              if (has_final_sale > 0 && cart_has_final_sale == false) {
                jQuery.ajax({
                  type: 'POST',
                  url: '/cart/update.js',
                  cache: false,
                  data: {
                    attributes: {
                      'Final Sale': 'Digital Course'
                    }
                  } ,
                  success: function(response) {
                    console.log("Add Final Sale Success")
                  }
                })
              }

              if (has_final_sale == 0 && cart_has_final_sale == true) {
                jQuery.ajax({
                  type: 'POST',
                  url: '/cart/update.js',
                  cache: false,
                  data: {
                    attributes: {
                      'Final Sale': ''
                    }
                  } ,
                  success: function(response) {
                    console.log("Remove Final Sale Success")
                  }
                })
              }
            },
            error: function (error) {
              console.error(error);
            }
          });
        }

        // Commerce UI must refresh even if analytics is blocked or never calls back.
        runOperations();

        try {
          var privacy = window.Shopify && window.Shopify.customerPrivacy;
          if (true && typeof window.gtag === 'function' && privacy &&
              typeof privacy.analyticsProcessingAllowed === 'function' && privacy.analyticsProcessingAllowed()) {
            window.gtag('event', 'remove_from_cart', {
              currency: cart.currency,
              value: Number((qty * price / 100).toFixed(2)),
              items: [
                {
                  item_id: sku,
                  item_name: title,
                  item_list_name: '/collections/',
                  price: Number((price / 100).toFixed(2)),
                  quantity: qty,
                  index: 1,
                },
              ]
            });
          }
        } catch (error) {
          // A tracking failure must not interrupt a successful cart change.
          console.warn('Cart analytics event could not be sent.');
        }
      },
      error: function error(XMLHttpRequest, textStatus) {
        var response = eval('(' + XMLHttpRequest.responseText + ')');
        response = response.description;
      }
    });
  },
  updateView: function updateView(cart, lineID) {
    if (cart.item_count > 0) {
      var _$$ajax;

      $.ajax((_$$ajax = {
        dataType: "json",
        async: false,
        cache: false
      }, _defineProperty(_$$ajax, "dataType", 'html'), _defineProperty(_$$ajax, "url", "/cart"), _defineProperty(_$$ajax, "success", function success(html) {
        if (lineID !== null) {
          var updatedItems = $(html).find('.cart__item-list .cart__card');
          var currentItems = $('.cart__item-list .cart__card'); // Checks if BOGO applied and there is a change in the number of line items

          if (updatedItems.length != currentItems.length) {
            var updatedCartList = $(html).find('.cart__item-list'); // Re-append cart items

            $('.cart__item-list').replaceWith(updatedCartList);
          }

          $(currentItems).each(function (index, element) {
            $(element).attr('data-line-item', index + 1);
            $(element).find('[data-line-item-key]').attr('data-line-item-key', index + 1);
          });
          var itemTotal = $(html).find("[data-line-item=\"".concat(lineID, "\"]")).find('.cart__total');
          var quantityInput = $(html).find("[data-line-item=\"".concat(lineID, "\"]")).find('.quantity-input');
          var itemPrice = $(html).find("[data-line-item=\"".concat(lineID, "\"]")).find('.cart__price');
          $("[data-line-item=\"".concat(lineID, "\"]")).find('.cart__total').replaceWith(itemTotal);
          $("[data-line-item=\"".concat(lineID, "\"]")).find('.quantity-input').replaceWith(quantityInput);
          $("[data-line-item=\"".concat(lineID, "\"]")).find('.cart__price').replaceWith(itemPrice);
        }

        var subtotal = $(html).find('.cart__subtotal-container');
        var discounts = $(html).find('.cart__discounts');
        var savings = $(html).find('.cart__total-savings');
        $('.cart__subtotal-container').replaceWith(subtotal);

        if (discounts.length > 0 && $('.cart__discounts').length < 1) {
          $('.cart__subtotal-container').before(discounts);
        } else {
          $('.cart__discounts').replaceWith(discounts);
        }

        if (savings.length > 0 && $('.cart__total-savings').length < 1) {
          $('.cart__subtotal-container').after(savings);
        } else {
          $('.cart__total-savings').replaceWith(savings);
        }

        $('[data-bind="itemCount"]').text(cart.item_count);
      }), _$$ajax));
    } else {
      $('.cart__empty-cart-message').removeClass('is-hidden');
      $('.cart__form').addClass('is-hidden');
      $('[data-ajax-cart-trigger]').removeClass('has-cart-count');
      $('[data-bind="itemCount"]').text('0');
    }

    if (Shopify.theme_settings.show_multiple_currencies) {
      convertCurrencies();
    }
  },
  unload: function unload($section) {
    // Clear event listeners in theme editor
    $('[data-cart-page-delete]').off();
  }
};
